import { useState, useEffect, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Tooltip, Checkbox, Grid, Box, Skeleton } from '@mui/material';
import { getFleetUtilizationApi,getAssetListApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import InfoIcon from '@mui/icons-material/Info';
import { globalGetService, globalDeleteService } from '../../../utils/globalApiServices';
import { FleetUtilizationList, rangeValidations } from '../components';
import NoRecordFound from '../../../shared_elements/NoRecordFound';
import { PageLoader, STableLoader, Pagination, DeletePopUp, FilterComponent } from '../../../shared_elements';
import { deleteUtilizationApi } from '../apiService';
import { ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import { RoleBaseAccess } from '../../../hoc';
import { PermissionWrapper } from '../../../wrappers';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getApiResponse } from '../../../utils/fileUpload';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import { trackActivity } from '../../../utils/mixpanel';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { getLesseeApi, getLessorAc,getOwnerListApi,  } from '../../../shared_elements/actionCreators';
import DeploymentBanner from '../../../shared_elements/components/DeploymentBanner';
import { getAircraftTypeList, getEngineTypeList } from '../../asset_listing/apiServices';
import { ASSET_TYPE_OPTIONS } from '../../../constants';
import DeploymentBannerWithOffset from '../../../shared_elements/components/DeploymentBannerWithOffSet';

const utilizationTypeOptions = [
    { label: 'Ferry Flight', value: 'Ferry Flight' },
    { label: 'CTA Entry for Delivery', value: 'CTA Entry for Delivery'},
    { label: 'Reporting Utilization', value: 'Reporting Utilization' },
    { label: 'Shop Visit', value: 'Shop Visit' },
    { label: 'Test Flight', value: 'Test Flight' },
];

const FleetHeader = ({ toggleBulkOps, item, bulk }) => {
    const deliveryCond = item?.find((items) => items?.utilization_type?.value === 4) && item?.length === 1
    const notDisItem=item?.filter(optionItem=>(optionItem?.utilization_type?.value !== 4 && optionItem?.status?.value !== 3 && !optionItem?.invoice_exist))
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ minWidth: '140px', whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['D'] }}>
                        <Checkbox
                            color='primary'
                            size='small'
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', notDisItem)}
                            checked={notDisItem?.length === bulk?.ids?.length && notDisItem?.length > 0}
                        />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '170px' }}> Asset</TableCell>
                <TableCell sx={{ minWidth: '190px' }}> Period</TableCell>
                <TableCell sx={{ minWidth: "110px" }}>Lessor/Holdco</TableCell>
				<TableCell sx={{ minWidth: "110px" }}>Owner/SPV</TableCell>
				<TableCell sx={{ minWidth: "110px" }}>Lessee</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> Flight Hours</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> Flight Cycles</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> FH:FC Ratio</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> TSN</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> CSN</TableCell>
                <TableCell sx={{ minWidth: '50px' }}> BH<Tooltip placement='top' title="Block Hours"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'smaller' }} color="primary"  /></Tooltip></TableCell>
                <TableCell sx={{ minWidth: '80px' }}> DeRate</TableCell>
                <TableCell sx={{ minWidth: '80px' }}> EGTM <Tooltip placement='top' title="EGT Margin"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'smaller' }} color="primary" /></Tooltip></TableCell>
                <TableCell sx={{ minWidth: '130px' }}> Utilization Type</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> Invoice Status</TableCell>
            </TableRow>
        </TableHead>
    )
}
const FleetUtilization = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const dispatch=useDispatch();
    const { enqueueSnackbar } = useSnackbar()
    const {  lessor, lessee,owner } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [fleetUtilization, setFleetUtilization] = useState({ list: [], pagination: {} });
    const [delFleetUtilization, setDelFleetUtilization] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null })
    const [filter, setFilter] = useState({});
    const[isExport,seIsExport]=useState(false)
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
	const [assetList, setAssetList] = useState([]);
    const [assetListLoading, setAssetListLoading] = useState(false);
    const [aircraftTypes, setAircraftTypes] = useState([]);
    const [engineTypes, setEngineTypes] = useState([]);
    const [drawerAssetType, setDrawerAssetType] = useState(undefined);
    const [drawerAircraftType, setDrawerAircraftType] = useState(undefined);
    const [drawerEngineType, setDrawerEngineType] = useState(undefined);

    useEffect(() => {
        setDrawerAssetType(undefined);
        setDrawerAircraftType(undefined);
        setDrawerEngineType(undefined);
    }, [filter.asset_type, filter.aircraft_type, filter.engine_type]);

    const fleetUtilizationFilterMenu = useMemo(() => {
        const activeAssetType = drawerAssetType === undefined ? filter.asset_type : drawerAssetType;
        const activeAircraftType = drawerAircraftType === undefined ? filter.aircraft_type : drawerAircraftType;
        const activeEngineType = drawerEngineType === undefined ? filter.engine_type : drawerEngineType;
        let filteredAssetList = assetList || [];
        if (activeAssetType) {
            filteredAssetList = filteredAssetList.filter(item => item.asset_type === activeAssetType);
            if (activeAssetType === 1 && activeAircraftType) {
                filteredAssetList = filteredAssetList.filter(item => item.aircraft_type_id === activeAircraftType);
            }
            if (activeAssetType === 2 && activeEngineType) {
                filteredAssetList = filteredAssetList.filter(item => item.engine_type_id === activeEngineType);
            }
        }
        return {
        asset_type: { title: 'Asset Type', inputType: 'dropdown', options: ASSET_TYPE_OPTIONS, valueKey: 'value', labelKey: 'label', multiple: false, dependentFields: ['aircraft_type', 'engine_type', 'asset_id'] },
        ...(activeAssetType === 1 ? { aircraft_type: { title: 'Aircraft Type', inputType: 'dropdown', options: aircraftTypes || [], valueKey: 'id', labelKey: 'name', multiple: false, dependentFields: ['asset_id'] } } : {}),
        ...(activeAssetType === 2 ? { engine_type: { title: 'Engine Type', inputType: 'dropdown', options: engineTypes || [], valueKey: 'id', labelKey: 'name', multiple: false, dependentFields: ['asset_id'] } } : {}),
        asset_id: { title: 'Asset', inputType: 'dropdown', options: filteredAssetList, valueKey: 'unique_key', labelKey: 'name', multiple: true, loading: assetListLoading, renderOption: (props, option) => ( <Box component="li" {...props} key={option.slug || option.unique_key}> {option.name} </Box> )},
        start_date: { title: 'Period Start Date', inputType: 'date' },
        end_date: { title: 'Period End Date', inputType: 'date' },
        utilization_type: { title: 'Utilization Type', inputType: 'dropdown', options: utilizationTypeOptions, valueKey: 'value', labelKey: 'label', multiple: false },
        lessor_name_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
        owner_id: { title: 'Owner/SPV', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
        lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: true },
        // block_hours_from: { title: 'BH (Block Hours) from', inputType: 'number', md: 6 },
        // block_hours_till: { title: 'BH (Block Hours) till', inputType: 'number', md: 6 },
        hours_from: { title: 'Flight Hours From', inputType: 'number', md: 6, is_decimal :true },
        hours_till: { title: 'Flight Hours Till', inputType: 'number', md: 6 , is_decimal :true},
        cycles_from: { title: 'Flight Cycles From', inputType: 'number', md: 6 , is_decimal :true},
        cycles_till: { title: 'Flight Cycles Till', inputType: 'number', md: 6 , is_decimal :true},
        // derate: { title: 'DeRate', inputType: 'number', md: 6 },
        // egtm: { title: 'EGTM', inputType: 'number', md: 6 },
        tsn_from: { title: 'TSN From', inputType: 'number', md: 6, is_decimal :true },
        tsn_till: { title: 'TSN Till', inputType: 'number', md: 6, is_decimal :true },
        csn_from: { title: 'CSN From', inputType: 'number', md: 6 , is_decimal :true},
        csn_till: { title: 'CSN Till', inputType: 'number', md: 6, is_decimal :true },
        onDependencyChange: (keyParam, value) => {
            if (keyParam === 'asset_type') setDrawerAssetType(value != null ? value : null);
            if (keyParam === 'aircraft_type') setDrawerAircraftType(value != null ? value : null);
            if (keyParam === 'engine_type') setDrawerEngineType(value != null ? value : null);
        },
        onOpen: () => { setDrawerAssetType(undefined); setDrawerAircraftType(undefined); setDrawerEngineType(undefined); },
        };
    }, [assetList, assetListLoading, owner, lessee, aircraftTypes, engineTypes, filter.asset_type, filter.aircraft_type, filter.engine_type, drawerAssetType, drawerAircraftType, drawerEngineType]);


    useEffect(() => {
        getFleetUtilization('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Fleet Utilization'})
        getAssetList();
         if (!lessee?.length) dispatch(getLesseeApi());
                    if (!lessor?.length) dispatch(getLessorAc());
                    if (!owner?.length) dispatch(getOwnerListApi());
        globalGetService(getAircraftTypeList()).then(response => {
            if (checkApiStatus(response)) setAircraftTypes(response?.data?.data || []);
        });
        globalGetService(getEngineTypeList()).then(response => {
            if (checkApiStatus(response)) setEngineTypes(response?.data?.data?.engineTypes || []);
        });
    }, [])
     const getAssetList = () => {
       setAssetListLoading(true);
       globalGetService(getAssetListApi()).then(response => {
         setAssetListLoading(false);
         if (checkApiStatus(response)) {
           const formatted = (response?.data?.data || []).map(item => ({
                   ...item,
                   unique_key: `${item.id}_${item.asset_type}`,
               }));
           setAssetList(formatted);
         }
       });
     };
   


    const getFleetUtilization = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        const apiQuery = { ...query };
        if (apiQuery.asset_id) {
          apiQuery.asset_id = apiQuery.asset_id.split(',').map(key => { const [id, assetType] = key.split('_'); return `(${id},${assetType})`; });
        }
        globalGetService(getFleetUtilizationApi(params, apiQuery)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setFleetUtilization(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })

    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments?.data?.attachments.filter(item => item?.slug !== deltedslug)
            }
        });
        getFleetUtilization('', { per_page: fleetUtilization?.pagination?.per_page });
    }
    const deleteUtilizationFn = () => {
        let delteId = bulk?.ids?.filter((item) => item?.utilization_type?.value !== 4).map(item => item?.master_id) || [];
        setLoading(true);
        globalDeleteService(deleteUtilizationApi(params), { master_ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? delteId : [delFleetUtilization?.data?.master_id] }
        )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Fleet Utilization`, success_msg: response?.data?.message, item_ids: delFleetUtilization?.data || bulk?.ids, response: response?.data })
                    setDelFleetUtilization({ modal: false, data: null });
                    setBulk({ modal: false, ids: [], type: '' })
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    getFleetUtilization('', { per_page: fleetUtilization?.pagination?.per_page });
                } else {
                    trackActivity('Item Deleted', { page_title: `Delete Fleet Utilization`, error_msg: response?.data?.message, item_ids: delFleetUtilization?.data || bulk?.ids, response: response?.data })
                    setLoading(false);
                    setBulk({ modal: false, ids: [], type: '' })
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                }
            })
    }

      const handleExport=()=>{
         seIsExport(true);
         globalGetService(getFleetUtilizationApi(params , { ...filter, export: true})).then((response)=>{
            if (checkApiStatus(response)){
              enqueueSnackbar(
                     response?.data.message,
                     { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                   );
                    seIsExport(false);
            }
        })
       }
    const onApplyFilter = (query) => {
        if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
            enqueueSnackbar('Period Start Date must be before End Date', { variant: 'error' });
            return false;
        }
        for (const item of rangeValidations) {
            const fromValue = query[item.from];
            const tillValue = query[item.till];
            if ( fromValue !== '' && fromValue !== null && fromValue !== undefined && tillValue !== '' && tillValue !== null && tillValue !== undefined ) {
                const fromNum = Number(fromValue);
                const tillNum = Number(tillValue);
                if (isNaN(fromNum) || isNaN(tillNum)) { enqueueSnackbar( `${item.label} values must be valid numbers`, { variant: 'error' } ); return false; }
                if (fromNum > tillNum) { enqueueSnackbar( `${item.label} From must be less than or equal to ${item.label} Till`, { variant: 'error' } ); return false; }
            }
        }
        setFilter(query);
        getFleetUtilization('', { ...query, page: 1, per_page: fleetUtilization?.pagination?.per_page || 50 });
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Fleet Utilization`, page_type: page_type, })
    }

    return (
        <div className="active-asset-section fleet-utlizations">
            {/* <DeploymentBanner /> */}
            <DeploymentBannerWithOffset>
                {(bannerHeight) => (
            <div className="active-asset-header" style={{padding: '0px'}}>
                <Paper elevation={0} className="lease-module-paper" sx={{ padding: '5px', marginBottom: '2px' }}>
                    <Grid container spacing={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <Grid size='grow' sx={{ minWidth: 0 }}>
                             {skeletonLoader ? <Skeleton variant="rounded" width={220} height={32} /> : <FilterComponent filter={filter} filterMenu={fleetUtilizationFilterMenu} getResponseBack={onApplyFilter} />}
                        </Grid>
                        <Grid size={{ md: 'auto', xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {skeletonLoader ? <Skeleton variant="rounded" width={220} height={32} /> : 
                    <ul className='list-inline' style={{ textAlign: 'right' }}>
                        <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {type:"global"} })}/> </li>
                        {bulk?.ids?.find((item) => item?.utilization_type?.value === 4) && bulk?.ids?.length === 1 ? null :
                            bulk?.type && bulk?.ids?.length ?
                                <>
                                    <li style={{marginInline:'5px'}}>
                                        <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                    </li>
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['D'] }}>
                                    <li>
                                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.filter((item) => item?.utilization_type?.value !== 4)?.length})`}</Button>
                                    </li>
                                    </PermissionWrapper>
                                </> : null
                        }
                        {fleetUtilization?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>  </li> : null}
                        {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['C'] }}>
                        <li> <Button variant="contained" color="primary" size='small' className='btn-primary'> Add Item </Button> </li>
                        </PermissionWrapper> */}
                    </ul>}
                        </Grid>
                    </Grid>
                </Paper>
                <Paper elevation={0} className="lease-detail-table lease-module-paper" sx={{ display: 'flex', flexDirection: 'column', maxHeight: `calc(100vh - ${130 + bannerHeight}px)`, height: 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={13} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <FleetHeader bulk={bulk} item={fleetUtilization?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {fleetUtilization?.list?.length > 0 && fleetUtilization?.list?.map((item, index) =>{
                                            const uploadedFileData = getApiResponse("utilization_master", item?.master_slug);
                                        return(
                                        <FleetUtilizationList
                                            uploadedFileData={uploadedFileData}
                                            viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                            key={index}
                                            item={item}
                                            bulk={bulk}
                                            ondeleteUtilizationFn={() => setDelFleetUtilization({ modal: true, data: item, })}
                                            toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                            onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data:{...item,slug:item?.master_slug}, mode: 'view',type:"list" })}
                                        />
                                    )})}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                    <Paper>
                        {!skeletonLoader && !fleetUtilization?.list?.length && <NoRecordFound />}
                        <Pagination
                            pagination={fleetUtilization?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getFleetUtilization('pageLoader', { ...filter, page: pageNum, per_page: fleetUtilization.pagination.per_page, }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getFleetUtilization('pageLoader', { ...filter, page: 1, per_page: perPage, }); }}
                        />
                    </Paper>
                </Paper>
            </div>
            )}
            </DeploymentBannerWithOffset>
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Fleet Utilization"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null })}
                    permissionKey='utilization'
                /> : null
            }
            {delFleetUtilization.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : delFleetUtilization.modal}
                    title={bulk.modal ? 'Delete All Fleet Utilization' : 'Delete Fleet Utilization'}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [] }) : setDelFleetUtilization({ modal: false, data: null })}
                    onDeleteRecords={() => deleteUtilizationFn()}
                /> : null}
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={revisionHistory?.type === "list" ? "utilization_master" :"utilization"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
            />
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default RoleBaseAccess(FleetUtilization, { application: 'lease_revamp', feature: 'utilization', operationType: ['R'] });
